import React from "react";
import FAQItem from "./FAQItem";

const SexToysFAQIndia = () => {
 const faqs = [
  {
    question: "Where can I buy sex toys online in India?",
    answer:
      "You can buy sex toys online in India from trusted adult wellness stores that provide discreet packaging, secure payments, and pan-India delivery.",
  },
  {
    question: "Is it legal to buy sex toys in India?",
    answer:
      "Yes, buying sex toys in India is legal. These products are sold as personal wellness items and shipped discreetly by reputed stores.",
  },
  {
    question: "Which are the most popular sex toys for men in India?",
    answer:
      "Popular sex toys for men in India include masturbators, pocket sleeves, penis rings, and delay sprays for pleasure and stamina.",
  },
  {
    question: "Which are the most popular sex toys for women in India?",
    answer:
      "Women in India prefer vibrators, bullet vibrators, wand massagers, clitoral stimulators, and kegel exercisers.",
  },
  {
    question: "Which sex toys are best for couples in India?",
    answer:
      "Couples often choose couple vibrators, remote-controlled toys, rings, and intimacy games to enhance bonding.",
  },
  {
    question: "I am buying sex toys for the first time. What should I choose?",
    answer:
      "First-time buyers should start with beginner-friendly toys like bullet vibrators or simple strokers with easy controls.",
  },
  {
    question: "Do sex toys get delivered discreetly in India?",
    answer:
      "Yes, trusted Indian adult stores deliver sex toys in plain, unbranded packaging for complete privacy.",
  },
  {
    question: "Is Cash on Delivery available for sex toys in India?",
    answer:
      "Many stores offer Cash on Delivery (COD) along with UPI and card payment options, depending on location.",
  },

  /* 🔥 NEW SEO QUESTIONS START */

  {
    question: "Are sex toys safe to use in India?",
    answer:
      "Yes, sex toys are safe to use when purchased from trusted Indian websites that sell body-safe, non-toxic materials such as medical-grade silicone.",
  },
  {
    question: "Which sex toys are best for beginners in India?",
    answer:
      "Beginner-friendly sex toys in India include bullet vibrators, basic massagers, simple masturbators, and couples rings with easy controls.",
  },
  {
    question: "Can unmarried people buy sex toys in India?",
    answer:
      "Yes, unmarried individuals can legally buy sex toys in India. These products are meant for personal wellness and do not require marital status verification.",
  },
  {
    question: "Do sex toy websites deliver across all Indian cities?",
    answer:
      "Most reputed sex toy websites deliver across metro cities, tier-2 cities, and many smaller towns across India, subject to courier availability.",
  },
  {
    question: "How long does sex toy delivery take in India?",
    answer:
      "Delivery usually takes 1–2 days in metro cities like Delhi, Mumbai, Bangalore, and 3–5 working days in other parts of India.",
  },
  {
    question: "Can I return or replace sex toys in India?",
    answer:
      "Due to hygiene reasons, most sex toys are non-returnable. However, replacements may be offered for damaged or defective products.",
  },
  {
    question: "Are online sex toy payments safe in India?",
    answer:
      "Yes, trusted Indian adult wellness websites use secure payment gateways, encrypted transactions, and privacy-protected billing.",
  },
  {
    question: "Why should I buy sex toys from an Indian website?",
    answer:
      "Buying from an Indian website ensures faster delivery, discreet packaging, local customer support, easier payments, and better privacy compliance.",
  },

  /* 🔥 NEW SEO QUESTIONS END */
];


  return (
    <div
      style={{
        backgroundColor: "#16000F",
        padding: "60px 20px",
      }}
    >
      <div style={{ maxWidth: "900px", margin: "0 auto" }}>
        <h1
          style={{
            color: "#B40F2F",
            textAlign: "center",
            marginBottom: "10px",
          }}
        >
          Top Questions About Sex Toys in India
        </h1>

        <p
          style={{
            color: "#B40F2F",
            textAlign: "center",
            marginBottom: "40px",
            fontSize: "16px",
          }}
        >
          Legal, safe & discreet buying guide for sex toys in India.
        </p>

        {faqs.map((faq, index) => (
          <FAQItem
            key={index}
            question={faq.question}
            answer={faq.answer}
          />
        ))}
      </div>
    </div>
  );
};

export default SexToysFAQIndia;
